import { IMutation, MutationContext } from '@aesop-fables/scrinium';
import { ApiKeys } from '../../../api/apis/ApiKeys';
import { ReportApi } from '../../../api/apis/ReportApi';
import { reloadReportCompartments } from '..';
import { SseApi } from '../../../api/apis/SseApi';
import {
  ReportGenerationService,
  reportGenerationServiceKey,
} from '../../../services/reportGeneration';

export class RegenerateOrgReport implements IMutation<void> {
  async execute(context: MutationContext<void>): Promise<void> {
    const { storage, container } = context;
    const api = container.get<ReportApi>(ApiKeys.Report);
    await api.regenerateOrgReport();
    await reloadReportCompartments(storage, ['orgReport']);
  }
}

export class RegenerateTeamReport implements IMutation<void> {
  async execute(context: MutationContext<void>): Promise<void> {
    const { storage, container } = context;
    const reportApi = container.get<ReportApi>(ApiKeys.Report);
    const reportGenerationService = container.get<ReportGenerationService>(
      reportGenerationServiceKey,
    );

    const {
      data: { emitterId },
    } = await reportApi.regenerateTeamReport();
    const url = container.get<SseApi>(ApiKeys.Sse).openStream(emitterId);

    await reportGenerationService.handleStreamStatus(url);
    await reloadReportCompartments(storage, ['teamReport', 'summedTeamReport']);
  }
}

export class RegenerateGroupReport implements IMutation<void> {
  async execute(context: MutationContext<void>): Promise<void> {
    const { storage, container } = context;
    const reportApi = container.get<ReportApi>(ApiKeys.Report);
    const reportGenerationService = container.get<ReportGenerationService>(
      reportGenerationServiceKey,
    );

    const {
      data: { emitterId },
    } = await reportApi.regenerateGroupReport();
    const url = container.get<SseApi>(ApiKeys.Sse).openStream(emitterId);

    await reportGenerationService.handleStreamStatus(url);
    await reloadReportCompartments(storage, ['groupReport', 'summedGroupReport']);
  }
}
